import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { GovernmentsModel, HorTypeModel, ImageTypesModel, MasterdataModel, RadTypeModel } from '../models/Masterdata.Model';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class masterdataService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }


  public getmasterCLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("Type", compCode);
      const options = {
          params: params
      };
      return this.http.get<MasterdataModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Masterfile/masterfileLookup', options);

  }
  public getmasterCLookupTopGov() {
    let params = new HttpParams();
    const options = {
        params: params
    };
    return this.http.get<MasterdataModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Masterfile/GovLookup');

}
public getmasterCLookupTopNat() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<MasterdataModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Masterfile/Natonalitylkup');

}
public getmasterCLookupTopImages() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<ImageTypesModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Masterfile/ImageTypesLookupTop');

}
public getmasterLookupTopGovernments() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<GovernmentsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Masterfile/GovernmentsLookupTop');

}
public getRadTypeLookupTopGov() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<RadTypeModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/RadType/RadTypeookupTop');

}
public getHorTypeLookupTopGov() {
  let params = new HttpParams();
  const options = {
      params: params
  };
  return this.http.get<HorTypeModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/HorType/HorTypeookupTop');

}
}
